import React, { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { UserContext } from "context/userContext";
import AutoCompleteComponent from "components/AutoCompleteComponent";
import getRole from "services/roleService";
import MDButton from "components/MDButton";
import { roleFonction, ADMIN_PAYS_ROLE, SUPER_ADMIN_ROLE } from "constant/role";
import useArrayOperation from "hooks/useArrayOperation";
import { ERROR } from "constant/message";
import { CurrentUserNiveau, checkRoleExist } from "utils/userInfos";
import { LAST_PATH } from "constant";
import { useNavigate } from "react-router-dom";

const { sortArray } = useArrayOperation();

const UserRole = () => {
  const { user, ApiService, handleLoad, canUpdate } = useContext(UserContext);
  const { getData, postData } = ApiService;
  const navigate = useNavigate();
  const [listRole, setListRole] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState([]);
  const [newUserRole, setNewUserRole] = useState([]);
  const [removedUserRole, setRemovedUserRole] = useState([]);
  const goToMain = () => {
    const loadData = {
      isAlert: true,
      message: "Opération effectuée avec succès",
      isLoading: false,
      alertSeverity: "success",
    };
    handleLoad(loadData);
    setTimeout(() => {
      const lastPath = localStorage.getItem(LAST_PATH);
      navigate(lastPath);
    }, 200);
  };
  const fetchRoleData = async () => {
    const data = await getRole(getData);
    const roleUser = data.map((i) => ({
      ...i,
      users: [
        {
          numTel: user?.numTel ?? "",
        },
      ],
    }));
    const niveauUser = CurrentUserNiveau();
    let filteredRolebyNiveau = roleUser;
    const isAdminPays = checkRoleExist(ADMIN_PAYS_ROLE);
    const isSuperAdmin = checkRoleExist(SUPER_ADMIN_ROLE);
    if (!isAdminPays && !isSuperAdmin) {
      filteredRolebyNiveau = roleUser.filter((x) => x.niveau > niveauUser);
    }
    setListRole(filteredRolebyNiveau);
  };
  const setCurrentRole = () => {
    const roleData = user?.roles.map((x) => {
      const fonctionData = roleFonction.find((y) => y.role === x.roleName);
      const item = {
        ...x,
        ...{ fonction: fonctionData?.fonction ?? x.roleName },
      };
      return item;
    });
    const currentRole = sortArray(roleData, "fonction");
    setUserRole(currentRole);
    setCurrentUserRole(currentRole);
  };
  useEffect(() => {
    setCurrentRole();
    fetchRoleData();
  }, []);
  const handleInputChange = (e) => {
    const { value } = e.target;
    const existingRoleName = new Set(currentUserRole.map((i) => i.roleName));
    const newRole = value.newValue.filter((i) => !existingRoleName.has(i.roleName));

    const uniqueRole = new Set();
    const selectedRole = value.newValue.filter((i) => {
      if (uniqueRole.has(i.roleName)) {
        return false;
      }
      uniqueRole.add(i.roleName);
      return true;
    });

    setUserRole(selectedRole);
    setNewUserRole(newRole);
  };
  const handleRemoveRole = (roleToRemove) => {
    try {
      const UserRoleValue = userRole.filter((i) => i.roleName !== roleToRemove.roleName);
      const newRole = newUserRole.filter((i) => i.roleName !== roleToRemove.roleName);
      setUserRole(UserRoleValue);
      setNewUserRole(newRole);
      const deletedRole = currentUserRole.filter((i) => i.roleName === roleToRemove.roleName);
      setRemovedUserRole(deletedRole);
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(error);
    }
  };
  const deleteRole = async () => {
    const endpoint = "Roles/user/remove";
    const dataForm = { numTel: user.numTel, roles: removedUserRole };
    const fetchData = await postData(endpoint, dataForm);
    if (fetchData !== ERROR) {
      goToMain();
    }
  };
  const saveRole = async () => {
    const endpoint = "Roles/assignUsersRoles";
    const dataForm = newUserRole;
    await postData(endpoint, dataForm);
    if (removedUserRole.length > 0) {
      deleteRole();
    } else {
      goToMain();
    }
  };
  const handleUpdateRole = async () => {
    if (!user.enabled) {
      const loadData = {
        isAlert: true,
        message: "Impossible de modifier le la fonction d'un utilisateur bloqué",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    } else if (newUserRole.length > 0) {
      saveRole();
    } else if (removedUserRole.length > 0) {
      deleteRole();
    }
  };

  return (
    <Box
      sx={{ padding: 2, border: "1px solid #ccc", borderRadius: 2, margin: 2 }}
      style={{ backgroundColor: "white" }}
    >
      <Box textAlign="center">
        <Typography variant="h6">Fonction de l&apos;utilisateur</Typography>
      </Box>
      <AutoCompleteComponent
        options={listRole}
        name="roles"
        label="Fonctions"
        value={userRole}
        onChange={handleInputChange}
        isResultObject
        isMultiSelect
        onRemove={handleRemoveRole}
        isDisabled={!canUpdate}
      />
      {canUpdate && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <MDButton type="submit" variant="gradient" color="info" onClick={handleUpdateRole}>
            Enregistrer
          </MDButton>
        </Box>
      )}
    </Box>
  );
};

export default UserRole;
